export enum BVEventType {
	CATEGORY = 'Category',
	EMBEDDED = 'Embedded',
	FEATURE = 'Feature', 
	MISC = 'Misc',
	PRODUCT = 'Product',
	SUBMISSION = 'Submission'
}

export interface BVEventObject {
	avgRating?: number,
	brand: string,
	bvProduct: string,
	categoryId: string,
	detail1?: string,
	detail2?: string,
	name?: string,
	numReviews?: number,
	percentRecommended?: number
	productId: string
	type: BVEventObjectType | BVEventType,
}

export interface BVTrackImpresionObject {
	brand: string,
	bvProduct: BVProduct,
	categoryId: string,
	contentId: string,
	contentType: string,
	productId: string
}

export interface BVInViewData {
	brand: string,
	bvProduct: BVProduct,
	productId: string
}

export interface TrackViewUCGObject {
	containerId: string,
	minPixels: number,
	minTime?: number
}

export enum BVEventObjectType {
	USED = 'Used'
}

export enum BVEventObjectName {
	FILTER = 'filter',
	HELPFULNESS = 'helpfulness',
	LINK = 'link',
	PAGINATE = 'paginate',
	READMORE = 'read_more',
	REPORT = 'report',
	SEARCH = 'search',
	SORT = 'sort',
	WRITE = 'write'
}

export enum BVProduct {
	ASKANDANSWER = 'AskAndAnswer',
	CURATIONS = 'Curations',
	RATINGSANDREVIEWS = 'RatingsAndReviews'
}

